import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "./index.css"; // Tailwind
import { useAuth } from "@/stores/auth";

const app = createApp(App);
app.use(router);

// Load token from storage on app start
useAuth().loadFromStorage();

app.mount("#app");
